import Page from "../../components/PrivacyPolicy/Page";
import { termsConditionData } from "./data";

const sections = termsConditionData;
const TermsCondition: React.FC = () => {
  return <Page pageTitle="Terms and Condition" sections={sections as any} />;
};

export default TermsCondition;
